import React from "react";
import Projects from "./projects/Projects";
import { Row, Col } from "react-bootstrap";
import ProjectCard from "./projects/ProjectCard";
import projects from "../../content/projects";

const MobileDevelopmentPage = () => {
  return (
    <Projects header={{ label: "Mobile Development" }}>
      <p>
        {" "}
        I build mobile applications for the Android & IOS platforms, using the
        powerful Android Studio and Flutter frameworks.
      </p>
      <Row>
        {projects
          .filter((project) => project.type === "Mobile")
          .map((project, index) => {
            return (
              <Col key={index} xl={4} lg={6} md={6} sm={12}>
                <ProjectCard
                  name={project.name}
                  img={project.img}
                  description={project.description}
                />
              </Col>
            );
          })}
      </Row>
    </Projects>
  );
};

export default MobileDevelopmentPage;
